/**
 * Copyright (c) [2020] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

/**
 * Helper to simplify to build the cssClass conditionally
 *
 * TODO: add unit tests
 *
 * @param {String} CSS classes to join
 * @returns {String} final cssClass properly joined
 */
function classNames(...classes) {
  return classes.filter((item) => !!item).join(' ');
}

/**
 * Helper to discard non truly values in a collection
 *
 * TODO: add unit tests
 *
 * @param {Array} collection to clean
 * @returns {Array} a new collection without false values
 */
function discardFalses(collection) {
  return collection.filter((i) => i);
}

/**
 * Helper to attach a stream to a video element
 *
 * @param {HTMLVideoElement} element of the DOM to attach the stream to
 * @param {MediaStream} WebRTC stream
 */
function attachStream(element, stream) {
  try {
    // In fact, this should work in all relatively new browsers. So maybe the
    // whole function could be dropped in favor of this line.
    element.srcObject = stream;
  } catch (e) {
    try {
      element.src = URL.createObjectURL(stream);
    } catch (e) {
      console.error("Error attaching stream to element");
    }
  }
}

const mixer = (streams) => {
  if (!streams || streams.length === 0) {
    //console.log("mixer: No streams to mix");
    return null;
  }
  
  const ctx = new AudioContext();
  // 确保 AudioContext 处于运行状态
  if (ctx.state === 'suspended') {
    ctx.resume();
  }
  
  const dest = ctx.createMediaStreamDestination();
  let hasAudioSource = false;
  
  // 遍历传入的每个流
  streams.forEach((stream, index) => {
    if(stream && stream.getAudioTracks && stream.getAudioTracks().length > 0) {
      const audioTracks = stream.getAudioTracks();
      console.log(`mixer: Stream ${index} has ${audioTracks.length} audio tracks`);
      
      audioTracks.forEach(track => {
        console.log(`mixer: Track ${track.id}, enabled: ${track.enabled}, readyState: ${track.readyState}, muted: ${track.muted}`);
        if (track.enabled && track.readyState === 'live' && !track.muted) {
          try {
            const source = ctx.createMediaStreamSource(new MediaStream([track]));
            source.connect(dest);
            hasAudioSource = true;
            console.log(`mixer: Connected track ${track.id} to destination`);
          } catch (err) {
            console.error(`mixer: Error connecting track ${track.id}:`, err);
          }
        }
      });
    }
  });
  
  if (!hasAudioSource) {
    console.log("mixer: No active audio sources found");
    // 即使没有源，也返回流以保持上下文活跃
    // 创建一个静音源以确保流持续
    const oscillator = ctx.createOscillator();
    oscillator.frequency.value = 0;
    oscillator.connect(dest);
    oscillator.start();
    console.log("mixer: Added silent oscillator to keep stream alive");
  }
  
  console.log("mixer: Created mixed stream with", dest.stream.getAudioTracks().length, "audio tracks");
  return dest.stream;
};

export {
  attachStream,
  classNames,
  discardFalses,
  mixer
};
